/**
 * Colour presets for {@link OnboardingCheckoutTable}. Kept beside the component rather than inside
 * it so the component file exports components only (`react-refresh/only-export-components`), the
 * same split as `forms/formFieldTokens.ts`.
 */

import { colors } from '../../../../styles/colors';
import type { OnboardingCheckoutTableColors } from './OnboardingCheckoutTable';

/**
 * Figma's `Abrechnung Card`, used by both BNPL screens: deductions in primary rather than the
 * default discount green, and a plain bold total on the card tint instead of the filled footer bar.
 */
export const CARD_TABLE_COLORS: Partial<OnboardingCheckoutTableColors> = {
  accent: colors.primary,
  footerSurface: 'transparent',
  footerText: colors.dark,
};
